var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSubscriptionsAnalyticsIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5670_25151)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.1719 0H10.5859V9.41406H20V8.82812C20 6.4782 19.0795 4.26352 17.408 2.59203C15.7365 0.920547 13.5218 0 11.1719 0ZM11.7578 8.24219V1.19406C15.5134 1.47961 18.5204 4.4866 18.8059 8.24219H11.7578Z",
    fill: "white",
    fillOpacity: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.41406 2.38281H8.82812C3.96027 2.38281 0 6.32559 0 11.1719C0 16.0304 3.97 20 8.82812 20C13.6744 20 17.6172 16.0397 17.6172 11.1719V10.5859H9.41406V2.38281ZM8.24219 9.7573L3.86297 5.37809C5.06141 4.36 6.57832 3.70262 8.24219 3.57676V9.7573ZM1.17188 11.1719C1.17188 9.27473 1.87293 7.53766 3.03039 6.20277L7.99949 11.1719L3.01852 16.1529C1.86809 14.8129 1.17188 13.0723 1.17188 11.1719ZM8.82812 18.8281C6.92773 18.8281 5.18707 18.1319 3.84715 16.9815L9.07082 11.7574H16.4232C16.1245 15.7068 12.8321 18.8281 8.82812 18.8281Z",
    fill: "white",
    fillOpacity: 0.9
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5670_25151"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubscriptionsAnalyticsIcon);
export default __webpack_public_path__ + "static/media/subscriptions-analytics-icon.06214b6b7b1a04366dfce71cdd27d670.svg";
export { ForwardRef as ReactComponent };